import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'hooks/useTranslation';
import logger from 'services/logger';
import { getURLWithUTMParameters } from 'components/ShareDialog/utils';
import { ShareMethod } from './ShareMethod';
import { ShareMethodComponent } from './types';

export const ShareMethodCopyLink: ShareMethodComponent = ({ url, onClick }) => {
  const [isCompleted, setIsCompleted] = useState(false);

  const timerRef = useRef<number>(undefined);
  const timerHandler = () => {
    setIsCompleted(false);
    onClick();
  };
  const setTimer = () => {
    timerRef.current = window.setTimeout(timerHandler, 1000);
  };

  useEffect(() => {
    setIsCompleted(false);
  }, [url]);
  useEffect(() => {
    return function cleanup() {
      if (timerRef.current !== undefined) {
        window.clearTimeout(timerRef.current);
      }
    };
  }, []);

  const t = useTranslation();
  const label = isCompleted
    ? t('shareLabelCopyLinkCompleted')
    : t('shareLabelCopyLink');

  async function handleClick(event: React.SyntheticEvent) {
    event.preventDefault();
    try {
      const shareURL = getURLWithUTMParameters(url, 'copy-link');
      await navigator.clipboard.writeText(shareURL);
      setIsCompleted(true);
      setTimer();
    } catch (e) {
      logger.error(e, "Couldn't copy URL to clipboard");
    }
  }

  return (
    <ShareMethod
      label={label}
      name="copy-link"
      onClick={handleClick}
      isShareCompleted={isCompleted}
    />
  );
};
